export default __webpack_public_path__ + "static/media/cahier-charges-audit.c4726543.jpg";